import { render, staticRenderFns } from "./DesignFoundationsMotion.vue?vue&type=template&id=7fecbd12"
import script from "./DesignFoundationsMotion.vue?vue&type=script&lang=js"
export * from "./DesignFoundationsMotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports